import Application from './Application'
import Admin from './Admin'
import Wallet from './Wallet'

const models = {
  
    application:Application,
    admin:Admin,
    wallet:Wallet
}

export default models;